import Cell from "./Cell";

export default class Grid {
	constructor(cols, rows) {
		this.numCols = cols;
		this.numRows = rows;
		this.cells = this.fillCells();
		this.startingCell = this.getStartingCell();
		this.endingCell = this.getEndingCell()
	}
	fillCells() {
		let counter = 0;
		let arr = [];
		for (let i = 0; i < this.numRows; i++) {
			for (let j = 0; j < this.numCols; j++) {
				arr.push(new Cell(j, i, counter))
				counter++
			}
		}
		return arr
	}
	getCell(x, y) {
		return this.cells.find(cell => cell.x == x && cell.y == y)
	}
	getStartingCell() {
		let x = Math.floor(Math.random() * (this.numCols - 2)) + 1
		let y = Math.floor(Math.random() * (this.numRows - 2)) + 1
		return this.getCell(x, y)
	}
	getEndingCell() {
		let start = this.startingCell;
		let end = this.getStartingCell();
		if (this.getDistance(start, end) > 2) {
			return end
		} else {
			return this.getEndingCell()
		}
	}
	getDistance(cell1, cell2) { //this gets steps to reach cell, not hypotenuse length
		let dx = Math.abs(cell1.x - cell2.x);
		let dy = Math.abs(cell1.y - cell2.y);
		return dx + dy
	}
	getNextCell(cell) {
		let newX = cell.x
		let newY = cell.y
		switch (cell.tile.out) {
			case 0: newY--; break
			case 1: newX++; break
			case 2: newY++; break
			case 3: newX--; break
			default: return ('something not right')
		}
		return this.getCell(newX, newY);
	}
}
